module.exports = __webpack_public_path__ + "homepage-headline.png?7fd7949c60dfafaf3460366ffa02c5db";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/homepage-headline.png
// module id = 179
// module chunks = 0